import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {StorefrontComponent} from '@spartacus/storefront';

@Component({
    selector: 'app-uig-header',
    templateUrl: './uig-header.component.html',
    styleUrls: ['./uig-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigHeaderComponent extends StorefrontComponent {

}
